import { Tooltip } from "@au-schein-de/au-ui-library";
import { useTranslation } from "react-i18next";
import { useVendorSelection } from "~/contexts/vendor-selection.context";
import { VendorFilterMapWrapper } from "~/features/pharmacy-map/vendor-filter-map-wrapper.component";

type DeliveryVendorFilterProps = {
	onPharmacySelectorOpenChange?: (isOpen: boolean) => void;
};

export function DeliveryVendorFilter({
	onPharmacySelectorOpenChange,
}: DeliveryVendorFilterProps) {
	const { t } = useTranslation("product");
	const {
		selectedVendorId,
		selectedDeliveryMethodKind,
		setSelectedVendor,
		vendor,
	} = useVendorSelection();

	return (
		<div className="flex flex-col w-full min-w-0 space-y-1.5 md:space-y-2">
			<div className="flex items-center gap-1 mb-0 md:mb-4">
				<h2 className="text-body-sm md:text-body text-gray-500">
					{t("vendor.map.selectPharmacy")}
				</h2>

				<Tooltip.Info info={t("filters.deliveryMethodsInfo")} />
			</div>

			<div className="grid gap-2 w-full md:grid-cols-1">
				<div className="min-w-0">
					<VendorFilterMapWrapper
						value={selectedVendorId}
						onChange={setSelectedVendor}
						onDropdownOpenChange={onPharmacySelectorOpenChange}
						deliveryMethodKind={selectedDeliveryMethodKind}
						defaultVendor={vendor}
					/>
				</div>
			</div>
		</div>
	);
}
